<template>
  <div class="nav-side-menu">
    <vue-progress-bar></vue-progress-bar>

    <div class="top-container">
      <div class="no-drag item text-center">
        <span class="not-side-button mb-2">
          <template v-if="showUploadLogo">
            <router-link to="/website/settings">
              <div
                class="position-absolute text-muted2 a-link ml-2 cursor-pointer"
                style="font-size: 11px"
              >
                <font-awesome-icon icon="long-arrow-alt-down" />
                {{ t('Upload your logo') }}
              </div>
            </router-link>
          </template>
          <router-link to="/">
            <img
              height="auto"
              width="120px"
              style="background-color: transparent; border: none"
              class="ml-2 py-3"
              v-bind:class="{ 'mt-2': showUploadLogo }"
              :src="$customdomain().logo"
            />
          </router-link>
        </span>
      </div>

      <div
        class="no-drag item"
        :class="{ activebg: $route.name == 'Dashboard' }"
      >
        <router-link
          to="/"
          class="nav-link cursor-pointer btn-noshadow side-button"
        >
          <font-awesome-icon class="ml-3 mr-2" icon="home" />{{
            t('Dashboard')
          }}
        </router-link>
      </div>
      <div class="d-none">
        <div class="no-drag item category-title" style="border-top: 0px">
          {{ t('Visitor') }}
        </div>

        <div
          class="no-drag item"
          :class="{
            activebg: $route.name == 'Visitor' || $route.name === 'Visitors',
          }"
        >
          <router-link
            to="/visitor/realtime"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="comment-alt" />{{
              t('Real Time')
            }}
          </router-link>
        </div>

        <div
          class="no-drag item"
          :class="{
            activebg: $route.name == 'Maps' || $route.name === 'VisitorMaps',
          }"
        >
          <router-link
            to="/visitor/map"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="poll-h" />{{ t('Maps') }}
          </router-link>
        </div>
        <div
          class="no-drag item"
          :class="{
            activebg:
              $route.name == 'Retention' || $route.name === 'VisitorRetention',
          }"
        >
          <router-link
            to="/visitor/retention"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="mouse-pointer" />{{
              t('Retention')
            }}
          </router-link>
        </div>
        <div
          class="no-drag item"
          :class="{
            activebg:
              $route.name == 'Acquisition' || $route.name === 'AcqChannel',
          }"
        >
          <router-link
            to="/visitor/acquisition"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="mouse-pointer" />{{
              t('Acquistion Channel')
            }}
          </router-link>
        </div>
      </div>
      <div v-if="feedbackVal || surveyVal">
        <div class="no-drag item category-title" style="border-top: 0px">
          {{ t('Insight') }}
        </div>

        <div
          v-if="feedbackVal"
          class="no-drag item"
          :class="{
            activebg:
              $route.name == 'Feedback' || $route.name === 'ViewFeedback',
          }"
        >
          <router-link
            to="/feedback"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="comment-alt" />{{
              t('Feedbacks')
            }}

            <span
              v-show="notificationCount != 0"
              class="badge-notify float-right"
              >{{ notificationCount }}</span
            >
          </router-link>
        </div>

        <div
          v-if="surveyVal"
          class="no-drag item"
          :class="{
            activebg: $route.name == 'Polls' || $route.name === 'ViewPolls',
          }"
        >
          <router-link
            to="/survey"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="poll-h" />{{
              t('Surveys')
            }}
          </router-link>
        </div>
        <div
          v-if="formAnalyticVal"
          class="no-drag item"
          :class="{ activebg: $route.name.includes('Form') }"
        >
          <router-link
            to="/form"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="file-alt" />{{
              t('Forms')
            }}
          </router-link>
        </div>
      </div>
      <div v-if="recordVal || heatmapVal || eventtrackVal">
        <div class="no-drag item category-title">{{ t('Behavior') }}</div>

        <div
          v-if="recordVal"
          class="no-drag item"
          :class="{ activebg: $route.name == 'Recordings' }"
        >
          <router-link
            to="/recordings"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="video" />{{
              t('Recordings')
            }}
          </router-link>
        </div>

        <div
          v-if="heatmapVal"
          class="no-drag item"
          :class="{
            activebg: $route.name.includes('Heatmap'),
          }"
        >
          <router-link
            v-if="heatmapOldVersion()"
            to="/heatmap"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="fire" />{{
              t('Heatmaps')
            }}
          </router-link>
          <router-link
            v-else
            to="/heatmap/continuous"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="fire" />{{
              t('Heatmaps')
            }}
          </router-link>
        </div>

        <div
          v-if="eventtrackVal"
          class="no-drag item"
          :class="{ activebg: $route.name == 'Events' }"
        >
          <router-link
            to="/events"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="mouse-pointer" />{{
              t('Event Tracking')
            }}
          </router-link>
        </div>

        <div
          v-if="day2expire < 1000 && isHowuku"
          class="no-drag item"
          :class="{ activebg: $route.name.includes('Automation') }"
        >
          <router-link
            to="/automation"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="paper-plane" />{{
              t('Automation')
            }}
          </router-link>
        </div>
      </div>
      <!-- <div v-if="abtestVal || personalizeVal">
        <div class="no-drag item category-title">{{ t('Experiment') }}</div>

        <div
          v-if="abtestVal"
          class="no-drag item"
          :class="{
            activebg:
              $route.name == 'A/B Split Test' || $route.name == 'A/B Result',
          }"
        >
          <router-link
            to="/ab-test"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="flask" />{{
              t('A/B Testing')
            }}
          </router-link>
        </div>

        <div
          v-if="personalizeVal"
          class="no-drag item"
          :class="{
            activebg:
              $route.name == 'Personalized Experience' ||
              $route.name == 'Personalized Experience Result',
          }"
        >
          <router-link
            to="/personalize"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="pencil-ruler" />{{
              t('Personalization')
            }}
          </router-link>
        </div>
      </div> -->
      <div v-if="analyticsVal || funnelVal || errortrackVal">
        <div class="no-drag item category-title">{{ t('Web Traffic') }}</div>

        <div
          v-if="analyticsVal"
          class="no-drag item"
          :class="{ activebg: $route.name == 'Analytics' }"
        >
          <router-link
            to="/analytics"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="chart-line" />{{
              t('Analytics')
            }}
          </router-link>
        </div>

        <!-- <div class="no-drag item" :class="{ activebg : $route.name == 'Visitors' }">
        <router-link to="/visitors" class="nav-link cursor-pointer btn-noshadow side-button">
          <font-awesome-icon class="ml-3 mr-2" icon="chart-line" />Visitors
        </router-link>
      </div>-->

        <div
          v-if="funnelVal"
          class="no-drag item"
          :class="{ activebg: $route.name == 'Funnel' }"
        >
          <router-link
            to="/funnel"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="filter" />{{
              t('Funnel')
            }}
          </router-link>
        </div>

        <!-- <div class="no-drag item" :class="{ activebg : $route.name == 'Users' }">
        <router-link to="/users" class="nav-link cursor-pointer btn-noshadow side-button">
          <font-awesome-icon class="ml-3 mr-2" icon="user-check" />Identified User
        </router-link>
      </div>-->

        <!-- <div
          v-if="errortrackVal"
          class="no-drag item"
          :class="{ activebg: $route.name == 'Error Log' }"
        >
          <router-link
            to="/error-log"
            class="nav-link cursor-pointer btn-noshadow side-button"
          >
            <font-awesome-icon class="ml-3 mr-2" icon="bug" />{{
              t('Error Tracking')
            }}
          </router-link>
        </div> -->
      </div>
    </div>
    <template v-if="$session.get('role') !== 3">
      <div class="btm-container w-100 p-3">
        <!-- <div class="no-drag item category-title">Free plan</div> -->
        <!-- <div class="no-drag item">
        <router-link
          v-if="$isFreePlan.includes($session.get('paid_plan')) || $isLegacyFreePlan.includes($session.get('paid_plan')) || day2expire"
          tag="button"
          to="/subscription"
          class="btn btn-first btn-primary-outline nav-link cursor-pointer text-center side-button"
        >Upgrade Plan</router-link>
        </div>-->
        <!-- && day2expire < 1000 -->
        <!-- <span class="mr-2 small text-center">
          <div class="item text-left">
            <p
              class="category-title mb-0 font-weight-bold text-left pl-0"
              style="line-height: 20px"
              v-if="isHowuku"
            >
              <template v-if="day2expire < 1000 && day2expire > 0"
                >Trial</template
              >
              <template v-if="day2expire > 1000">Lifetime</template>
              {{ setAgencyName(plan.plan_name) }} Plan
            </p>
            <p
              class="category-title mb-0 font-weight-bold text-left pl-0"
              style="line-height: 20px"
              v-else-if="
                !isHowuku &&
                $session.get('role') !== 3 &&
                $session.get('role') !== 2
              "
            >
              <template v-if="day2expire < 1000 && day2expire > 0"
                >Trial</template
              >
              <template v-if="day2expire > 1000">Lifetime</template>
              {{ setAgencyName(plan.plan_name) }} Plan
            </p>
            <div class="row" :key="monthly" v-if="isHowuku">
              <div class="col-md-5">
                <p class="mb-1 pt-1">Pageview</p>
              </div>
              <div class="col-md-7 text-right">
                <p class="mb-1 pt-1">
                  {{ numberFormat(monthly) }}
                  {{ numberToText(pageviewLimit) }}
                </p>
              </div>
            </div>
            <div
              class="row"
              :key="monthly"
              v-else-if="
                !isHowuku &&
                $session.get('role') !== 3 &&
                $session.get('role') !== 2
              "
            >
              <div class="col-md-5">
                <p class="mb-1 pt-1">Pageview</p>
              </div>
              <div class="col-md-7 text-right">
                <p class="mb-1 pt-1">
                  {{ numberFormat(monthly) }}
                  {{ numberToText(pageviewLimit) }}
                </p>
              </div>
            </div>
            <div
              :key="monthly"
              class="mb-3 progress progress-mini clearfix"
              style="height: 3px !important"
              v-if="isHowuku"
            >
              <div
                v-bind:class="{
                  'progress-bar': cap100((monthly / pageviewLimit) * 100) < 90,
                  'progress-warning':
                    cap100((monthly / pageviewLimit) * 100) >= 90,
                }"
                role="progressbar"
                :style="
                  'width: ' +
                  cap100((monthly / pageviewLimit) * 100) +
                  '% !important;'
                "
                v-bind:aria-valuenow="cap100((monthly / pageviewLimit) * 100)"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <div
              :key="monthly"
              class="mb-3 progress progress-mini clearfix"
              style="height: 3px !important"
              v-else-if="
                !isHowuku &&
                $session.get('role') !== 3 &&
                $session.get('role') !== 2
              "
            >
              <div
                v-bind:class="{
                  'progress-bar': cap100((monthly / pageviewLimit) * 100) < 90,
                  'progress-warning':
                    cap100((monthly / pageviewLimit) * 100) >= 90,
                }"
                role="progressbar"
                :style="
                  'width: ' +
                  cap100((monthly / pageviewLimit) * 100) +
                  '% !important;'
                "
                v-bind:aria-valuenow="cap100((monthly / pageviewLimit) * 100)"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <p
              class="mb-1 text-danger"
              v-if="day2expire > 0 && day2expire < 1000 && day2expire > 0"
            >
              Trial will expire in {{ day2expire }} days
            </p>
            <p
              class="text-primary cursor-pointer font-weight-bold"
              v-if="
                $isFreePlan.includes($session.get('paid_plan')) ||
                ($isLegacyFreePlan.includes($session.get('paid_plan')) &&
                  isHowuku)
              "
              @click="$router.push({ path: '/subscription' })"
            >
              Upgrade Plan
            </p>
            <p
              class="text-primary cursor-pointer font-weight-bold"
              v-else-if="
                $isFreePlan.includes($session.get('paid_plan')) ||
                ($isLegacyFreePlan.includes($session.get('paid_plan')) &&
                  !isHowuku &&
                  $session.get('role') !== 3 &&
                  $session.get('role') !== 2)
              "
              @click="$router.push({ path: '/subscription' })"
            >
              Upgrade Plan
            </p>
          </div>
        </span> -->
      </div>
    </template>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import { store } from '@/store'

/* eslint-disable */
export default {
  mixins: [clickaway],
  store,
  watch: {
    '$store.getters.widget_id': {
      handler: function () {
        this.loadData()
      },
      deep: true,
    },
    '$store.getters.notifFeedback': {
      handler: function (v) {
        this.notificationCount = v
      },
      deep: true,
    },
  },
  data: function () {
    return {
      notificationCount: 0,
      planTotalLimit: 0,
      monthly: 0,
      feedbackVal: 0,
      surveyVal: 0,
      recordVal: 0,
      heatmapVal: 0,
      eventtrackVal: 0,
      formAnalyticVal: 0,
      abtestVal: 0,
      personalizeVal: 0,
      analyticsVal: 0,
      funnelVal: 0,
      errortrackVal: 0,
      widgets: {},
      acl_data: {},
      pageviewLimit: 0,
      contentStatus: '',
      day2expire: null,
      plan: {},
      showUploadLogo: false,
      isHowuku: false,
      isAdmin:
        this.$session.get('role') === 0 || this.$session.get('role') === 1,
    }
  },
  beforeCreate() {
    this.$http.get(process.env.API_ENDPOINT + '/plan/info').then((response) => {
      let data = response.data
      this.plan = data[this.$session.get('paid_plan')]
      this.planTotalLimit = data[this.$session.get('paid_plan')].pageview
      this.pageviewLimit = data[this.$session.get('paid_plan')].pageview
    })
    this.$http.get(process.env.API_ENDPOINT + '/trial').then((response) => {
      let data = response.data
      this.day2expire =
        data[0].days_to_expire > 0 ? data[0].days_to_expire : null
      this.$session.set('day2expire', this.day2expire)
    })
  },
  mounted() {
    this.isLocalhost = window.location.host.includes('localhost')
    this.isHowuku =
      window.location.host === 'app.howuku.com' ||
      window.location.host.includes('localhost')
    setTimeout(() => {
      // not sure why timeout is needed but without it would be getting 0 value
      this.loadData()
    }, 1000)
    this.showUploadLogo =
      window.location.host !== 'app.howuku.com' &&
      this.$customdomain().logo === 'https://cdn.howuku.com/images/logo.png' &&
      this.$isPremiumPlan.includes(this.$session.get('paid_plan'))
  },
  methods: {
    heatmapOldVersion() {
      return localStorage.getItem('heatmap_preference') === 'v1'
    },
    setAgencyName(n) {
      if (n === 'Premium' && this.$session.get('lifetimedeal')) return 'Agency'
      return n
    },
    numberToText(n) {
      if (n === 0) return ''
      if (n >= 1000000) return '/ ' + (n / 1000000).toString() + 'M'
      if (n >= 1000) return '/ ' + (n / 1000).toString() + 'K'
      return '/ ' + n
    },
    numberFormat(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    feature(data, value) {
      return data.includes(value)
    },
    loadData: function () {
      // this.$router.push({ path: '/dashboard' })
      let options = {
        widget_id: this.$session.get('widget_id'),
      }

      this.$http
        .post(process.env.API_ENDPOINT + '/report/monthly', options)
        .then((response) => {
          let data = response.data
          setTimeout(() => {
            this.loading = true

            for (let i in data) {
              this.monthly = data[i].value
            }
          })
        })

        this.$http
        .post(process.env.API_ENDPOINT + '/getWidgetsNoCache', {
          widget_id: this.$session.get('widget_id'),
        })
        .then((response) => {
          let data = response.data
          this.$session.set('website_limit', data[0].pageview_limit)
          if (data[0].pageview_limit)
            this.pageviewLimit = data[0].pageview_limit
          else this.pageviewLimit = this.planTotalLimit

          this.acl_data = data[0].feature_acl
          this.feedbackVal = this.feature(this.acl_data, 'feedback')
          this.surveyVal = this.feature(this.acl_data, 'survey')
          this.recordVal = this.feature(this.acl_data, 'recording')
          this.heatmapVal = this.feature(this.acl_data, 'heatmap')
          this.eventtrackVal = this.feature(this.acl_data, 'eventtrack')
          this.formAnalyticVal = this.feature(this.acl_data, 'formanalytic')
          this.abtestVal = this.feature(this.acl_data, 'abtest')
          this.personalizeVal = this.feature(this.acl_data, 'personalize')
          this.analyticsVal = this.feature(this.acl_data, 'analytics')
          this.funnelVal = this.feature(this.acl_data, 'funnel')
          this.errortrackVal = this.feature(this.acl_data, 'errortrack')

          this.notificationCount = this.$store.getters.notifFeedback
        })
      // this.$router.push({ path: '/dashboard' })
    },
    cap100(n) {
      return n < 100 ? n : 100
    },
    logout: function () {
      this.$router.push({ path: '/logout' })
    },
  },
}
</script>

<style>
/* Hide scrollbar for Chrome, Safari and Opera */
</style>



// WEBPACK FOOTER //
// src/layouts/menus/SideMenuOld.vue